import React from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';

// Style
import './tags-search-box.scss';

const TagsSearchBox = ({ tags, onChange, isActive }) => {
  let options = [];

  tags.forEach((tag) => {
    if (tag?.nodes?.length) {
      tag.nodes.forEach((node) => {
        if (!options.map((option) => option.value).includes(node.value)) {
          options.push({ value: node.slug, label: node.name });
        }
      });
    }
  });

  options = [...new Set(options)];

  if (isActive) {
    return (
      <div>
        <Select
          className="tags-search-box"
          classNamePrefix="tags-search"
          placeholder="Search tags"
          closeMenuOnSelect
          options={options}
          onChange={(event) => onChange(event)}
          isMulti
        />
      </div>
    );
  }
  return null;
};

TagsSearchBox.defaultProps = {
  isActive: true,
};

TagsSearchBox.propTypes = {
  tags: PropTypes.array.isRequired, // eslint-disable-line
  onChange: PropTypes.func.isRequired,
  isActive: PropTypes.bool,
};

export default TagsSearchBox;
